module.exports = __webpack_public_path__ + "static/media/Spinner.57095264.gif";